(function() {

  $('[data-slick]').slick({
    nextArrow: '<i class="fas fa-chevron-right slick-next"></i>',
    prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
    infinite: true,
    adaptiveHeight: true,
    speed: 300,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 800,
        settings: {
          arrows: false,
          centerMode: false,
          variableWidth: false
        }
      }
    ]
  });

})();